import { render, staticRenderFns } from "./AsideBanner.vue?vue&type=template&id=7c0fe020&scoped=true"
import script from "./AsideBanner.vue?vue&type=script&lang=js"
export * from "./AsideBanner.vue?vue&type=script&lang=js"
import style0 from "./AsideBanner.vue?vue&type=style&index=0&id=7c0fe020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0fe020",
  null
  
)

export default component.exports